<template>
  <button
    class="flex items-center gap-4 justify-between text-left text-blue w-full"
    :aria-label="shownHeaderWhenCollapsed ? label : 'Expand ' + label"
    :aria-expanded="open"
  >
    <div class="flex items-center gap-2">
      <LazyFrontendServiceFilterToggleableToggle v-if="toggleable" :filter-id="filterId" />
      <UIcon v-if="icon && shownHeaderWhenCollapsed" :name="icon" size="24" />
      <div v-if="shownHeaderWhenCollapsed" class="font-bold font-brown">
        {{ label }}
      </div>
    </div>
    <slot></slot>
    <UIcon
      v-if="shownHeaderWhenCollapsed"
      name="i-heroicons-chevron-down-20-solid"
      class="w-6 h-6 ms-auto transform transition-transform duration-200 mx-2.5"
      :class="{ 'rotate-180': open }"
    />
  </button>
</template>

<script setup lang="ts">
import type { FilterIds } from '~/types/FilterIds'

const props = defineProps({
  toggleable: Boolean,
  filterId: {
    type: String as PropType<FilterIds>,
    required: true
  },
  open: {
    type: Boolean,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false,
    default: ''
  },
  hideAccordianHeader: {
    type: Boolean,
    required: false,
    default: false
  }
})

const shownHeaderWhenCollapsed = computed(() => {
  return !props.hideAccordianHeader || (props.hideAccordianHeader && !props.open)
})
</script>
